module.exports = __webpack_public_path__ + "img/center08.aa4fad16.png";